import React, { useState } from "react";

const LandingPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone_number: "",
    occupation: "",
  });
  const [responseMessage, setResponseMessage] = useState("");

  // Handle input changes for all fields, with custom logic for phone numbers
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone_number") {
      // Remove all non-digits
      let cleaned = value.replace(/\D/g, "").slice(0, 10); // Limit to 10 digits

      // Format to (xxx) xxx-xxxx
      if (cleaned.length < 4) {
        
      } else if (cleaned.length < 7) {
        cleaned = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      } else {
        cleaned = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
      }

      setFormData((prev) => ({ ...prev, phone_number: cleaned }));
    } else {
      // Default handler for other fields
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://highlandsevents.com/api/submit_form.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setResponseMessage(errorData.error || "An unexpected error occurred.");
        return;
      }

      const data = await response.json();
      setResponseMessage(data.message || "Form submitted successfully!");
    } catch (error) {
      console.error("Error:", error);
      setResponseMessage(`There was an error submitting the form. ${error.message || ""}`);
    }
  };

  return (
    <div style={styles.container}>
      {/* Left Section */}
      <div style={styles.leftSection}>
        {/* <div style={styles.logoContainer}>
          <img src="/logo.png" alt="Advantage Realty Logo" style={styles.logo} />
          <img src="/headshot.JPEG" alt="Host Headshot" style={styles.headshot} />
        </div> */}
        <h1 style={styles.title}>Sign Up for Appreciation Events!</h1>
        <p style={styles.description}>
          Join us in celebrating professionals like government workers, first responders,
          military personnel, teachers and more! The appreciation events are free as a way to thank you for
          your service and dedication to our community. Sign up to stay informed about
          upcoming events.
        </p>
        <br />
        <p style={styles.description}>
          We respect your privacy and are committed to protecting your personal information.
          We will never sell or share your contact details with third parties, and all provided
          information will be used exclusively to keep you updated about these events.
        </p>
      </div>

      {/* Right Section (Form) */}
      <div style={styles.rightSection}>
        <h2 style={styles.formTitle}>Join the Event List</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>NAME:</label>
            <input
              type="text"
              name="name"
              placeholder="Required"
              value={formData.name}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>LAST NAME:</label>
            <input
              type="text"
              name="surname"
              placeholder="Required"
              value={formData.surname}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>EMAIL:</label>
            <input
              type="email"
              name="email"
              placeholder="Required"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          {/* <div style={styles.formGroup}>
            <label style={styles.label}>PHONE NUMBER:</label>
            <input
              type="text"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              style={styles.input}
            />
          </div> */}
          <div style={styles.formGroup}>
            <label style={styles.label}>OCCUPATION:</label>
            <select
              name="occupation"
              value={formData.occupation}
              onChange={handleChange}
              required
              style={styles.input}
            >
              <option value="">Select your occupation</option>
              <option value="government">Government</option>
              <option value="first responder">First Responder</option>
              <option value="military">Military / Veteran</option>
              <option value="teacher">Teacher</option>
              <option value="healthcare">Healthcare</option>
            </select>
          </div>
          <button type="submit" style={styles.button}>
            Submit
          </button>
          <div style={styles.cButton}>
            <a
              href="mailto:nextbendev@gmail.com"
              style={styles.cButtonStyle}
            >
              Contact Me
            </a>
          </div>
        </form>
        {responseMessage && (
          <p
            style={{
              marginTop: "20px",
              color: responseMessage.includes("error") ? "red" : "green",
              textAlign: "center",
            }}
          >
            {responseMessage}
          </p>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    minHeight: "100vh",
    fontFamily: "'Roboto', sans-serif",
    backgroundColor: "#f4f4f9",
    flexWrap: "wrap",
  },
  cButton: {
    textAlign: "center", 
    marginTop: "10px"
  },
  cButtonStyle: {
    fontSize: "0.85rem",
    color: "#555",
    textDecoration: "underline",
    opacity: 0.8,
  },
  leftSection: {
    flex: 1,
    backgroundColor: "#001f3f",
    color: "#fff",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  logo: {
    width: "300px",
    height: "auto",
    marginRight: "10px",
    marginBottom: "20px",
    maxWidth: "80%",
  },
  headshot: {
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    objectFit: "cover",
    maxWidth: "80%",
  },
  title: {
    fontSize: "2rem",
    marginBottom: "20px",
  },
  description: {
    fontSize: "1rem",
    lineHeight: "1.5",
    maxWidth: "500px",
    margin: "0 auto",
  },
  rightSection: {
    flex: 1,
    backgroundColor: "#fff",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderLeft: "5px solid #ff4136", // Red Accent
  },
  formTitle: {
    fontSize: "1.8rem",
    color: "#001f3f", // Navy Blue
    marginBottom: "20px",
    textAlign: "center",
  },
  form: {
    width: "100%",
    maxWidth: "400px",
    margin: "0 auto",
  },
  formGroup: {
    marginBottom: "15px",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "1rem",
    width: "100%",
    boxSizing: "border-box",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#001f3f", // Navy Blue
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "background-color 0.3s",
    width: "100%",
  },
  "@media (maxWidth: 768px)": {
    container: {
      flexDirection: "column",
    },
    leftSection: {
      borderRight: "none",
      borderBottom: "5px solid #ff4136",
      padding: "20px",
    },
    rightSection: {
      padding: "20px",
      borderLeft: "none",
    },
    title: {
      fontSize: "1.5rem",
    },
    formTitle: {
      fontSize: "1.5rem",
    },
  },
};



export default LandingPage;
